import { defineComponent as _defineComponent } from 'vue';
import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, vModelSelect as _vModelSelect, vShow as _vShow, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    class: "c-modal p-topPreview",
    style: { "display": "block", "z-index": "500" }
};
const _hoisted_2 = { class: "p-topPreview__inner" };
const _hoisted_3 = { class: "p-topPreview__top" };
const _hoisted_4 = /*#__PURE__*/ _createStaticVNode("<option value=\"\">選択してください</option><option value=\"論文\">論文</option><option value=\"レポート\">レポート</option><option value=\"契約書類\">契約書類</option><option value=\"公文書\">公文書</option><option value=\"マニュアル\">マニュアル</option><option value=\"エッセイ\">エッセイ</option><option value=\"ポップ(明るくて、楽しげな)\">ポップ</option>", 8);
const _hoisted_12 = [
    _hoisted_4
];
const _hoisted_13 = ["disabled"];
const _hoisted_14 = {
    class: "u-display--flex u-flex-align-center u-mgLeft--10",
    style: { "display": "inline-flex" }
};
const _hoisted_15 = /*#__PURE__*/ _createStaticVNode("<div class=\"p-topPreviewContents\"><div class=\"p-topPreviewContents__left\"><h3 class=\"p-topPreview__subtitle\">アレンジ前</h3><div><pre id=\"js-before-preview\"></pre></div></div><div class=\"p-topPreviewContents__right\"><h3 class=\"p-topPreview__subtitle--blue\">アレンジ後</h3><div><pre id=\"js-after-preview\"></pre></div></div></div>", 1);
const _hoisted_16 = { class: "p-generateBtn__wrapper u-display--flex u-flex-align-center u-pdRight--20 c-modalSticky" };
const _hoisted_17 = ["disabled"];
import { ref } from 'vue';
import { streamChatCompletion, formatText } from '../../utils/helper';
import AiProcessingIndicator from './AiProcessingIndicator.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ArrangeModal',
    props: {
        closeModal: { type: Function },
        baseUrl: {},
        clientId: {},
        maxTextLength: {}
    },
    emits: ['update'],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const selected = ref('');
        const generated = ref(false);
        const generatePendding = ref(false);
        const inputPrompt = ref('');
        const emit = __emit;
        function initModal() {
            inputPrompt.value = '';
            selected.value = '';
            generated.value = false;
            const before = document.getElementById('js-before-preview');
            const after = document.getElementById('js-after-preview');
            if (before)
                before.innerText = '';
            if (after)
                after.innerText = '';
        }
        function close() {
            initModal();
            props.closeModal();
        }
        const arrangePrompts = [
            '論文',
            'レポート',
            '契約書類',
            '公文書',
            'マニュアル',
            'エッセイ',
            'ホップ',
        ];
        function complete() {
            const after = document.getElementById('js-after-preview');
            if (!after)
                return;
            if (after.innerText.length <= 0 || generated.value === false) {
                alert('アレンジを実行してください');
                return;
            }
            if (!confirm('テキストを上書きしますか？'))
                return;
            // 改行ごとにdivで囲む
            const formmated = formatText(after.innerText);
            emit('update', formmated);
            initModal();
            props.closeModal();
        }
        const stopSignal = ref(new AbortController());
        async function execArrange() {
            if (generatePendding.value)
                return;
            const after = document.getElementById('js-after-preview');
            if (!after)
                return;
            after.innerText = '';
            if (inputPrompt.value === '' && selected.value === null) {
                alert('どちらかを選択してください');
                return;
            }
            const before = document.getElementById('js-before-preview');
            if (!before)
                return;
            if (props.maxTextLength < before.innerText.length) {
                alert('文字数が多すぎます');
                return;
            }
            inputPrompt.value != '';
            generated.value = false;
            let prompt = '';
            let isInput = false;
            if (selected.value)
                prompt = selected.value;
            if (inputPrompt.value != '')
                prompt = inputPrompt.value, isInput = true;
            const url = props.baseUrl + '/gpt/arrange';
            const body = {
                text: before?.innerText,
                prompt: prompt,
                isInput: isInput,
                model: 'gpt-5-search-api',
                clientId: props.clientId,
            };
            stopSignal.value = new AbortController();
            generatePendding.value = true;
            try {
                const generator = streamChatCompletion(url, body, stopSignal.value.signal);
                for await (const text of generator) {
                    after.innerText = after.innerText + text;
                }
                generated.value = true;
            }
            catch (error) {
                if (!(error instanceof DOMException && error.name === 'AbortError')) {
                    console.error('アレンジエラー:', error);
                    alert('アレンジに失敗しました');
                }
            }
            finally {
                generatePendding.value = false;
            }
        }
        function stopArrange() {
            stopSignal.value.abort();
            generatePendding.value = false;
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "c-inputText--max450",
                            placeholder: "アレンジ内容を入力するか、右のプルダウンで選択",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((inputPrompt).value = $event)),
                            id: ""
                        }, null, 512), [
                            [_vModelText, inputPrompt.value]
                        ]),
                        _createTextVNode("　or　 "),
                        _withDirectives(_createElementVNode("select", {
                            name: "",
                            id: "",
                            class: "c-inputSelect--max170 u-mgRight--10",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((selected).value = $event))
                        }, _hoisted_12, 512), [
                            [_vModelSelect, selected.value]
                        ]),
                        _withDirectives(_createElementVNode("button", {
                            type: "submit",
                            class: "c-btn--reflect",
                            onClick: _cache[2] || (_cache[2] = ($event) => (execArrange())),
                            disabled: generatePendding.value
                        }, "アレンジする", 8, _hoisted_13), [
                            [_vShow, !generatePendding.value]
                        ]),
                        _withDirectives(_createElementVNode("div", _hoisted_14, [
                            _createVNode(AiProcessingIndicator, {
                                cancelable: "",
                                onCancel: _cache[3] || (_cache[3] = ($event) => (stopArrange()))
                            })
                        ], 512), [
                            [_vShow, generatePendding.value]
                        ])
                    ]),
                    _hoisted_15,
                    _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("button", {
                            type: "button",
                            id: "js-cancel-fix",
                            class: "c-btn--off u-mgRight--10",
                            onClick: _cache[4] || (_cache[4] = ($event) => (close()))
                        }, "キャンセル"),
                        _createElementVNode("button", {
                            type: "button",
                            class: _normalizeClass(["c-btn--reflect", !generated.value ? 'c-btn--off--disable' : '']),
                            onClick: _cache[5] || (_cache[5] = ($event) => (complete())),
                            disabled: generatePendding.value
                        }, "この文章を採用する", 10, _hoisted_17)
                    ])
                ])
            ]));
        };
    }
});
